// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { DialogContent } from '@material-ui/core';

// Internal Dependencies
import MText from '../../../common/MText';
import Editor from '../../../post/article/editor';
import { IsEmpty } from '../../../../common/checks';
import { Colours } from '../../../../common/constants';

const SubmitContent = ({ modal, handleValueUpdate }) => (
  <DialogContent>
    <div className="d-flex flex-column mb-4">
      <MText bold size={13} colour={Colours.Black} text="Question" />
      <Editor
        minHeight="6rem"
        onChangeDescription={(qns) => handleValueUpdate({ qns })}
        description={IsEmpty(modal.qns) ? '' : modal.qns}
        allowUpload={false}
        allowImagePaste={false}
      />
    </div>
    <div className="d-flex flex-column mb-4">
      <MText bold size={13} colour={Colours.Black} text="Answer" />
      <Editor
        minHeight="14rem"
        onChangeDescription={(answer) => handleValueUpdate({ answer })}
        description={IsEmpty(modal.answer) ? '' : modal.answer}
        allowUpload={false}
        allowImagePaste={false}
      />
    </div>
  </DialogContent>
);

SubmitContent.propTypes = {
  modal:             PropTypes.shape(Object).isRequired,
  handleValueUpdate: PropTypes.func.isRequired,
};

export default SubmitContent;
